import { render, staticRenderFns } from "./roleAdd.vue?vue&type=template&id=41903ada&scoped=true"
import script from "./roleAdd.vue?vue&type=script&lang=js"
export * from "./roleAdd.vue?vue&type=script&lang=js"
import style0 from "./roleAdd.vue?vue&type=style&index=0&id=41903ada&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41903ada",
  null
  
)

export default component.exports